import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    HoverCardContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const HoverCardContext = createContext<HoverCardContextType | undefined>(undefined);

export const useHoverCardContext = ({
    part
}: {
    part: string;
}): HoverCardContextType | undefined => {
    const context = useContext(HoverCardContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `HoverCard.${part}: must be rendered inside <HoverCard>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
